export default "__VITE_ASSET__CQn8zd77__"